import axios from 'axios';
import { API } from '../../constants';
import _, { get } from 'lodash';
import { push as PushRouter } from 'connected-react-router';

const createAction = name => ({
    CART_DATA_FETCHING: `${name}_CART_DATA_FETCHING`,
    GET_CART_DATA: `${name}_GET_CART_DATA`,

    CREATE_CART: `${name}_CREATE_CART`, //For product page
    ADD_OR_UPDATE_PRODUCT_TO_CART: `${name}_ADD_OR_UPDATE_PRODUCT_TO_CART`, //For product page
    AUTO_CLOSE_DIALOG_ADD_PRODUCT_TO_CART: `${name}_AUTO_CLOSE_DIALOG_ADD_PRODUCT_TO_CART`,

    UPDATE_PRODUCT_IN_CART_PENDING: `${name}_UPDATE_PRODUCT_IN_CART_PENDING`, //For cart page
    UPDATE_PRODUCT_IN_CART: `${name}_UPDATE_PRODUCT_IN_CART`, //For cart page
    UPDATE_PRODUCT_IN_CART_FALIED: `${name}_UPDATE_PRODUCT_IN_CART_FALIED`, //For cart page

    OPEN_DIALOG_DELETE_ITEM_IN_CART: `${name}_OPEN_DIALOG_DELETE_ITEM_IN_CART`, //For cart page
    DELETE_PRODUCT_IN_CART: `${name}_DELETE_PRODUCT_IN_CART`, //For cart page
    CLOSE_DIALOG_DELETE_ITEM_IN_CART: `${name}_CLOSE_DIALOG_DELETE_ITEM_IN_CART`, //For cart page
    DESTROY_CART: `${name}_DESTROY_CART`, //For cart page

    OPEN_DIALOG_DELETE_UNAVAILIABLE_ITEM: `${name}_OPEN_DIALOG_DELETE_UNAVAILIABLE_ITEM`, //For cart page
    DELETE_UNAVAILIABLE_ITEM: `${name}_DELETE_UNAVAILIABLE_ITEM`, //For cart page
    CLOSE_DIALOG_DELETE_UNAVAILIABLE_ITEM: `${name}_CLOSE_DIALOG_DELETE_UNAVAILIABLE_ITEM`, //For cart page

    OPEN_DIALOG_ITEM_OVER_STOCK: `${name}_OPEN_DIALOG_ITEM_OVER_STOCK`, //For cart page
    CLOSE_DIALOG_ITEM_OVER_STOCK: `${name}_CLOSE_DIALOG_ITEM_OVER_STOCK`, //For cart page

    // ADD_PRODUCT_TO_CART: `${name}_ADD_PRODUCT_TO_CART`,
    OPEN_DIALOG_BEFORE_CONFIRMING_ORDER: `${name}_OPEN_DIALOG_BEFORE_CONFIRMING_ORDER`, //For cart page
    CLOSE_DIALOG_BEFORE_CONFIRMING_ORDER: `${name}_CLOSE_DIALOG_BEFORE_CONFIRMING_ORDER`, //For cart page

    CHECK_OUT_DATA: `${name}_CHECK_OUT_DATA`, //For cart page

    ADD_BUY_NOW_ITEM: `${name}_ADD_BUY_NOW_ITEM`,
    CLEAR_BUY_NOW_ITEM: `${name}_CLEAR_BUY_NOW_ITEM`,

    ADD_BUY_NOW: `${name}_ADD_BUY_NOW`,
    UPDATE_BUY_NOW: `${name}_UPDATE_BUY_NOW`,
    CLEAR_BUY_NOW: `${name}_CLEAR_BUY_NOW`,

    UPDATE_PROMOTION_PENDING: `${name}_UPDATE_PROMOTION_PENDING`,
    UPDATE_PROMOTION_SUCCESS: `${name}_UPDATE_PROMOTION_SUCCESS`,
    UPDATE_PROMOTION_FALIED: `${name}_UPDATE_PROMOTION_FALIED`,

    CLEAR_DISCOUNT_CODE: `${name}_CLEAR_DISCOUNT_CODE`
});

export const CART = createAction('CART');

export const GetCartData = (fromRespPayment = false) => async (dispatch, getState) => {
    dispatch({ type: CART.CART_DATA_FETCHING });

    const { login, language, cart } = getState();
    try {
        let result = null;

        if (login.isAuthenticated || localStorage.getItem("Hello")) {
            result = await axios
                .get(
                    `${API.GET_CART_DATA}?customerId=${login.firebaseAuth.uid}&discountCode=${cart?.discountCode}`, 
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': language.currentLanguage
                        }
                    }
                )
                .then(res => res.data)
                .catch(error => Promise.reject(error));
            localStorage.removeItem("cartGuest");
        } else {
            
            if (fromRespPayment)
                localStorage.removeItem("cartGuest");
            else {
                let data = JSON.parse(localStorage.getItem("cartGuest")) || [];
    
                result = await axios
                    .post(
                        API.GET_CART_ITEM_STOCK, 
                        {
                            cart: data,
                            discountCode: cart?.discountCode
                        }, 
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': language.currentLanguage
                            }
                        }
                    )
                    .then(res => res.data)
                    .catch(err => Promise.reject(err));
    
                localStorage.setItem("cartGuest", JSON.stringify(data));
            }
        }

        dispatch({
            type: CART.GET_CART_DATA,
            payload: PrepareCart(result.data, result.promotion)
        });
    } catch (error) {
        dispatch({
            type: CART.GET_CART_DATA,
            payload: { data: [] }
        });
    }
};

export const CreateCart = (model, eventName) => async (dispatch, getState) => {
    const { login, language } = getState();

    try {
        let result = "", data = [{ ...model }];
    
        if (login.isAuthenticated) {
            const params = {
                customerId: login.firebaseAuth.uid,
                data
            };
            result = await axios
                .post(API.CREATE_CART, params, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                })
                .then(res => res.data)
                .catch(error => Promise.reject(error));
        } else {
            localStorage.setItem("cartGuest", JSON.stringify(data));
        }
    
        dispatch({
            type: CART.CREATE_CART,
            payload: {
                data: result,
                dialogAddProductToCart: eventName === 'add' ? true : false
            }
        });
    } catch (err) { console.log(err) }

};

export const AutoCloseDialogAddProductToCart = () => dispatch => {
    dispatch({ type: CART.AUTO_CLOSE_DIALOG_ADD_PRODUCT_TO_CART });
};

export const UpdateProductInCart = (itemUpdate, NewQty, itemSelected) => async (dispatch, getState) => {
    dispatch({ type: CART.UPDATE_PRODUCT_IN_CART_PENDING });

    try {
        const { login, cart, language } = getState();

        itemUpdate.qty = parseInt(NewQty);
        const NewCartData = (login.isAuthenticated ? cart.data : JSON.parse(localStorage.getItem("cartGuest"))).map(item => {
            if (item.itemId === itemUpdate.itemId) {
                return itemUpdate;
            }
            return item;
        });

        if (login.isAuthenticated) {
            const params = {
                customerId: login.firebaseAuth.uid,
                data: NewCartData,
                itemSelected,
                discountCode: cart.discountCode
            };
    
            const result = await axios
                .put(API.UPDATE_CART_DATA, params, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                })
                .then(res => res.data)
                .catch(error => Promise.reject(error));
    
            dispatch({
                type: CART.UPDATE_PRODUCT_IN_CART,
                payload: PrepareCart(NewCartData, result)
            });
        } else {
            localStorage.setItem("cartGuest", JSON.stringify(NewCartData));
            dispatch(UpdatePromotion(itemSelected));
        }

    } catch (error) { }
};

export const OpenDialogDeleteItemInCart = (deleteItem, type = "normal") => dispatch => {
    dispatch({
        type: CART.OPEN_DIALOG_DELETE_ITEM_IN_CART,
        payload: { ...deleteItem, type: type }
    });
};

export const DeleteItemInCart = (deleteItem, itemSelected) => async (dispatch, getState) => {
    const { cart, login, language } = getState();

    const NewCartData = (
        login.isAuthenticated 
            ? cart.data 
            : JSON.parse(localStorage.getItem("cartGuest"))
    ).filter(item => item.itemId !== deleteItem.itemId);

    if (cart.buyNowItem && deleteItem.itemId === cart.buyNowItem.itemId) {
        dispatch({ type: CART.CLEAR_BUY_NOW_ITEM });
    }

    if (login.isAuthenticated) {
        if (NewCartData.length === 0) {
            const params = {
                customerId: login.firebaseAuth.uid
            };
    
            await axios
                .delete(
                    API.DELETE_CART,
                    { params },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': language.currentLanguage
                        }
                    }
                )
                .then(res => res.data)
                .catch(error => Promise.reject(error));
    
            dispatch({ type: CART.DESTROY_CART });
        } else {
            const params = {
                customerId: login.firebaseAuth.uid,
                data: NewCartData,
                itemSelected,
                discountCode: cart.discountCode
            };
    
            let result = await axios
                .put(API.UPDATE_CART_DATA, params, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': language.currentLanguage
                    }
                })
                .then(res => res.data)
                .catch(error => Promise.reject(error));
            dispatch({
                type: CART.DELETE_PRODUCT_IN_CART,
                payload: PrepareCart(NewCartData, result)
            });
        }
    } else {
        if (NewCartData.length === 0) {
            localStorage.removeItem("cartGuest");
            dispatch({ type: CART.DESTROY_CART });
        } else {
            localStorage.setItem("cartGuest", JSON.stringify(NewCartData));
            dispatch(UpdatePromotion(itemSelected));
        }
    }

};

export const CloseDialogDeleteItemInCart = () => dispatch => {
    dispatch({ type: CART.CLOSE_DIALOG_DELETE_ITEM_IN_CART });
};

export const CartOpenDialogItemOverStock = () => dispatch => {
    dispatch({ type: CART.OPEN_DIALOG_ITEM_OVER_STOCK });
};

export const CartCloseDialogItemOverStock = () => dispatch => {
    dispatch({ type: CART.CLOSE_DIALOG_ITEM_OVER_STOCK });
};

export const AddOrUpdateProductToCart = (newProduct, eventName) => async (dispatch, getState) => {
    const { cart, login, language } = getState();
    
    let cartData = login.isAuthenticated ? cart.data: JSON.parse(localStorage.getItem("cartGuest"));
    let SameProductSameSize = cartData.some(currentProduct => {
        if (currentProduct.itemId === newProduct.itemId) {
            currentProduct.qty += newProduct.qty;
            return true;
        }
        return false;
    });

    if (!SameProductSameSize) {
        cartData = [...cartData, { ...newProduct }];
    }

    if (login.isAuthenticated) {
        const params = {
            customerId: login.firebaseAuth.uid,
            data: cartData
        };
    
        await axios
            .put(API.UPDATE_CART_DATA, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));
    } else {
        localStorage.setItem("cartGuest", JSON.stringify(cartData));
    }
    dispatch({
        type: CART.ADD_OR_UPDATE_PRODUCT_TO_CART,
        payload: {
            data: cartData,
            dialogAddProductToCart: eventName === 'add' ? true : false
        }
    });

    if (eventName === 'buynow') {
        dispatch({
            type: CART.ADD_BUY_NOW_ITEM,
            payload: { ...newProduct }
        });
    }
};

export const OpenDialogDeleteUnAvailiableItem = deleteItem => dispatch => {
    dispatch({
        type: CART.OPEN_DIALOG_DELETE_UNAVAILIABLE_ITEM,
        payload: deleteItem
    });
};

export const DeleteUnAvailiableItemInCart = () => async (dispatch, getState) => {
    const { cart, login, language } = getState();

    let NewCartData = login.isAuthenticated 
            ? cart.data 
            : JSON.parse(localStorage.getItem("cartGuest"));

    NewCartData = _.filter(NewCartData, item => !cart.deleteUnAvailiableItem.includes(item.itemId));

    let result = cart.promotion;

    if (login.isAuthenticated) {
        const params = {
            customerId: login.firebaseAuth.uid,
            data: NewCartData
        };
    
        result = await axios
            .put(API.UPDATE_CART_DATA, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));
        
    } else {
        localStorage.setItem("cartGuest", JSON.stringify(NewCartData));
    }

    dispatch({
        type: CART.DELETE_UNAVAILIABLE_ITEM,
        payload: PrepareCart(NewCartData, result)
    });
};

export const CloseDialogDeleteUnAvailiableItem = () => dispatch => {
    dispatch({ type: CART.CLOSE_DIALOG_DELETE_UNAVAILIABLE_ITEM });
};

export const CartOpenDialogBeforeConfirmingOrder = () => dispatch => {
    dispatch({ type: CART.OPEN_DIALOG_BEFORE_CONFIRMING_ORDER });
};

export const CartCloseDialogBeforeConfirmingOrder = () => dispatch => {
    dispatch({ type: CART.CLOSE_DIALOG_BEFORE_CONFIRMING_ORDER });
};

export const CheckItemActive  = (checkOutSelected) =>  async (dispatch, getState) =>{
    const { language } = getState();

    try{

        let result = await axios
        .post(API.CHECK_ITEM_ACTIVE, checkOutSelected, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': language.currentLanguage
            }
        })
        .then(res => res.data)
        .catch(error => Promise.reject(error));
        return result.isActive
    } 
    catch (error) {
        console.log(error);
        return false
    }
}

export const CartCheckOutData = (checkOutSelected, promotionCartSelected, { responcePromotionitem }, colorselected ,sizeselected ,promotiontotal) =>  async (dispatch, getState) =>  {
    const { cart, language, login } = getState();
    const { buyNow } = cart;
    
    let items = buyNow.status 
        ? buyNow.item 
        : login.isAuthenticated 
            ? cart.data 
            : JSON.parse(localStorage.getItem("cartGuest"));
    let checkOutData = _.filter(items, item => checkOutSelected.includes(item.itemId));
    let restItemInCart = _.filter(items, item => !checkOutSelected.includes(item.itemId));

    let proCartSelected = promotionCartSelected.map(itemId => {
        let proPromotion = responcePromotionitem
            ?.find(pro => pro.promotionid == itemId.slice(0, 1));
        let modelPromotion = proPromotion
            ?.item.find(model => 
                model.modelId == itemId.slice(2) 
                && (model?.item.some(item => 
                    (
                        !item?.rgbColor 
                        || colorselected.includes(model.modelId+item.rgbColor)
                    ) 
                    && sizeselected.includes(model.modelId+item.sizeName)
                ))
            );
        let itemPromotion = modelPromotion
            ?.item.find(item => 
                (
                    !item?.rgbColor 
                    || colorselected.includes(modelPromotion.modelId+item.rgbColor)
                ) 
                && sizeselected.includes(modelPromotion.modelId+item.sizeName)
            );
        return { 
            ...itemPromotion,
            promotionid: proPromotion?.promotionid,
            id: itemId, 
            qty: itemPromotion?.qty || 0,
            price: modelPromotion?.promotionPrice || 0
        }
    })

    dispatch({
        type: CART.CHECK_OUT_DATA,
        payload: {
            buyNow: buyNow.status,
            checkOutData,
            restItemInCart,
            promotionCartSelected: proCartSelected, 
            colorselected,
            sizeselected,
            promotiontotal
        }
    });
    
    dispatch(PushRouter(`${language.basenameURL}/checkout`));
    return true;

};

export const ClearBuyNowItemInCart = () => dispatch => {
    dispatch({ type: CART.CLEAR_BUY_NOW_ITEM });
};

export const ClearDiscountCode = () => dispatch => {
    dispatch({ type: CART.CLEAR_DISCOUNT_CODE });
};

// Buy now
export const AddToBuyNow = (data, eventName) => (dispatch, getState) => {
    const { cart } = getState();
    let items = cart?.buyNow?.item || [];
    let same = items.some(item => {
        if (item.itemId === data.itemId) {
            item.qty += data.qty;
            return true;
        }
        return false;
    });
    dispatch({
        type: CART.ADD_BUY_NOW,
        payload: {
            data: !same ? [ ...items, { ... data } ] : items,
            dialogAddProductToCart: eventName === 'add' ? true : false
        }
    })
}

export const UpdateBuyNow = (data, NewQty) => (dispatch, getState) => {
    const { cart } = getState();
    dispatch({
        type: CART.UPDATE_BUY_NOW,
        payload: cart?.buyNow?.item?.map(item => item.itemId === data.itemId ? ({ ...item, qty: NewQty }) : ({ ...item })) || []
    })
}

export const ClearBuyNow = (deleteItem, clear = false) => (dispatch, getState) => {
    const { cart } = getState();
    dispatch({
        type: CART.CLEAR_BUY_NOW,
        payload: clear ? [] : cart?.buyNow?.item?.filter(item => item.itemId !== deleteItem.itemId) || []
    })
}

export const UpdatePromotion = (itemSelected, discountCode) => async (dispatch, getState) => {
    dispatch({
        type: CART.UPDATE_PROMOTION_PENDING
    });
    try {
        const { cart, login, language } = getState();

        const data = login.isAuthenticated ? cart.data: JSON.parse(localStorage.getItem("cartGuest")) || [];

        const params = {
            customerId: login.firebaseAuth?.uid,
            data,
            itemSelected
        };

        if ((discountCode != "" && cart?.discountCode) || discountCode) params["discountCode"] = discountCode || cart.discountCode;

        const result = await axios
            .post(API.GET_PROMOTION, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));
        dispatch({
            type: CART.UPDATE_PROMOTION_SUCCESS,
            payload: PrepareCart(data, result, discountCode == "" ? "": params?.discountCode || "")
        })
    } catch (err) {
        dispatch({ type: CART.UPDATE_PROMOTION_FALIED })
    }
}

const PrepareCart = (data, promotion, discountCode = "") => {
    return { data, promotion, discountCode };
}